/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { ChevronDownIcon, ChevronUpIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/xdp';

const styles = {
  toggleEligibleDegreesInfo: css`
    display: inline-flex;
    align-items: center;
    gap: var(--cds-spacing-100);
  `,
};

const ToggleButtonForStreamlinedMWebEligibleDegrees = ({ collapsed }: { collapsed: boolean }) => (
  <span
    css={styles.toggleEligibleDegreesInfo}
    aria-label={collapsed ? _t('Read more about earning degree credit') : _t('Read less about earning degree credit')}
  >
    {collapsed ? _t('Expand to learn more') : _t('Show less')}
    {collapsed ? <ChevronDownIcon size="small" /> : <ChevronUpIcon size="small" />}
  </span>
);

export default ToggleButtonForStreamlinedMWebEligibleDegrees;
